import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { ContentBox } from "@mittwald/flow-components/dist/components/ContentBox";
import { MoneyValue } from "@mittwald/flow-components/dist/components/MoneyValue";
import {
  ResourceList,
  useResourceList,
} from "@mittwald/flow-components/dist/components/ResourceList";
import { Column } from "@mittwald/flow-components/dist/components/ResourceList/components/Column";
import { filterFactory } from "@mittwald/flow-components/dist/components/ResourceList/hooks/useResourceList/filterFactory";
import { iconDomain } from "@mittwald/flow-icons/dist/domain";
import React from "react";
import z from "zod";
import { includeFilter } from "../../../lib/filter";
import type DomainPrice from "../../../model/domain/prices/DomainPrice";
import { DomainPriceList } from "../../../model/domain/prices/DomainPriceList";
import { withValidatedProps } from "../../withValidatedProps";

export default withValidatedProps(z.any(), () => {
  const domainPriceList = DomainPriceList.useLoadAll();

  const filter = filterFactory<DomainPrice>()
    .fulltextFilter((domainPrice, searchText) =>
      includeFilter(
        domainPrice.tld.replace(/[^a-zA-Z]+/g, ""),
        searchText.replace(/[^a-zA-Z]+/g, ""),
      ),
    )
    .get();

  const tldPriceList = useResourceList<DomainPrice>({
    resources: domainPriceList.useItemsSorted(),
    filter,
    idAccessor: "id",
    nameAccessor: "name",
    bodyColumns: [
      {
        id: "mStudioAvailable",
        renderer: (renderer) => (
          <Column
            icon={renderer.resource.mStudio ? faCheck : faXmark}
            iconColor={
              renderer.resource.mStudio
                ? "espelkampGreen-$300"
                : "amaranthRed-$300"
            }
            text={{ text: "mStudio" }}
            tooltip={
              renderer.resource.mStudio ? undefined : { id: "requestTld" }
            }
          />
        ),
      },
      {
        id: "controlCenterAvailable",
        renderer: (renderer) => (
          <Column
            icon={renderer.resource.controlCenter ? faCheck : faXmark}
            iconColor={
              renderer.resource.controlCenter
                ? "espelkampGreen-$300"
                : "amaranthRed-$300"
            }
            text={{ text: "Kundencenter" }}
            tooltip={
              renderer.resource.controlCenter ? undefined : { id: "requestTld" }
            }
          />
        ),
      },
      {
        id: "priceAt",
        renderer: (renderer) => (
          <Column
            text={{
              id: "price",
              values: {
                price: <MoneyValue value={renderer.resource.startPrice} />,
              },
            }}
          />
        ),
      },
    ],
    icon: iconDomain,
  });

  return (
    <ContentBox>
      <ResourceList
        {...tldPriceList}
        alwaysShowFilter
        columnLayout={{
          name: { responsivePriority: 1 },
          body: [
            { key: "mStudioAvailable" },
            { key: "controlCenterAvailable" },
            { key: "priceAt", responsivePriority: 2, maxWidth: 100 },
          ],
        }}
        hideTilesView
        rowsPerPage={10}
      />
    </ContentBox>
  );
});
